import { render, staticRenderFns } from "./CourseContentsTemplate17.vue?vue&type=template&id=767b06e5&"
import script from "./CourseContentsTemplate17.vue?vue&type=script&lang=js&"
export * from "./CourseContentsTemplate17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports